var $7513a1b075b503d5$exports = {};
$7513a1b075b503d5$exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};


export {$7513a1b075b503d5$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
